var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (buttonText, config, content, title) {
buf.push("<div class=\"content-scroll content-fit content-ver text-center block-v-md\"><div class=\"content-scroll-inner\"><div class=\"block-v-md\"><h1 class=\"slide-up\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"slide-up delay-1 text-md\">" + (null == (jade_interp = content) ? "" : jade_interp) + "</div></div>");
if ( config.contextRequiresExitButton)
{
buf.push("<div class=\"block-v-md\"><div class=\"btn btn-solid slide-up\">" + (null == (jade_interp = buttonText) ? "" : jade_interp) + "</div></div>");
}
buf.push("</div></div>");}.call(this,"buttonText" in locals_for_with?locals_for_with.buttonText:typeof buttonText!=="undefined"?buttonText:undefined,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"content" in locals_for_with?locals_for_with.content:typeof content!=="undefined"?content:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}